import { withBreakpointRange } from '@optimus-web/core';
import { DialogProvider, getBreakpointRangeDefault, isMobileOrTablet, WithBreakpointRange } from '@mews-commander/ui';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import NavbarSearch from '../../search/containers/NavbarSearch';
import { Assistant } from '../../assistant';
import { SearchBarWrapper } from './styles';

interface Props extends WithBreakpointRange {
    mobileSearchOpened?: boolean;
    scope: string;
    handleToggleClick: () => void;
}

const SearchMenu = (props: Props) => {
    const { breakpointRange, mobileSearchOpened, scope, handleToggleClick } = props;

    const assistantEnabled: boolean = useFeatureFlag(FeatureFlag.assistantEnabled);
    const defaultBreakPointRange = getBreakpointRangeDefault();

    return !assistantEnabled ? (
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        <SearchBarWrapper opened={mobileSearchOpened} isMobileOrTablet={isMobileOrTablet(breakpointRange)}>
            <NavbarSearch {...props} scope={scope} />
        </SearchBarWrapper>
    ) : (
        <DialogProvider>
            <Assistant
                breakpointRange={defaultBreakPointRange}
                mobileSearchOpened={mobileSearchOpened}
                handleBackClick={handleToggleClick}
            />
        </DialogProvider>
    );
};

export default withBreakpointRange(SearchMenu);
